export default __webpack_public_path__ + "static/summer_holiday-0d60806c774471249b446bbb7931af25.jpg";